<div class ="flex flex-col m-30 mt-72 h-3/4 w-3/6 p-20 items-center">
  <a class="w-full m-10 flex justify-start text-xl text-gray cursor-pointer" (click)="goBack()">Go Back</a>
  @if (!isLoading) {
    <app-playerdetail class="h-full hover:shadow-lg" [playerId]="playerId"></app-playerdetail>
  }
</div>
